const USERS_KEY = "himmelstor_users";
const CURRENT_USER_KEY = "himmelstor_admin_user";

export const ROLES = { admin: "Admin", editor: "Editor" };

const defaultUsers = [
  { username: "admin", password: "admin123", role: "admin" },
];

function ensureRole(u) {
  return u.role === "admin" || u.role === "editor" ? u : { ...u, role: "admin" };
}

function loadUsers() {
  try {
    const raw = localStorage.getItem(USERS_KEY);
    if (raw) {
      const parsed = JSON.parse(raw);
      if (Array.isArray(parsed) && parsed.length > 0) {
        return parsed.map(ensureRole);
      }
    }
  } catch (e) {}
  return [...defaultUsers];
}

function saveUsers(users) {
  localStorage.setItem(USERS_KEY, JSON.stringify(users));
}

export function getUsers() {
  return loadUsers();
}

export function getCurrentUser() {
  const username = sessionStorage.getItem(CURRENT_USER_KEY);
  if (!username) return null;
  const users = loadUsers();
  const user = users.find((u) => u.username === username);
  return user ? { username: user.username, role: user.role } : null;
}

export function setCurrentUser(username) {
  if (username) sessionStorage.setItem(CURRENT_USER_KEY, username);
  else sessionStorage.removeItem(CURRENT_USER_KEY);
}

export function canManageUsers() {
  const current = getCurrentUser();
  return current && current.role === "admin";
}

export function addUser(username, password, role = "editor") {
  const users = loadUsers();
  const trimmed = (username || "").trim().toLowerCase();
  if (!trimmed || !password) return { ok: false, error: "Username and password required." };
  if (users.some((u) => u.username.toLowerCase() === trimmed)) return { ok: false, error: "Username already exists." };
  const r = role === "admin" ? "admin" : "editor";
  users.push({ username: trimmed, password, role: r });
  saveUsers(users);
  return { ok: true };
}

export function removeUser(username) {
  const users = loadUsers();
  if (users.length <= 1) return { ok: false, error: "Cannot remove the last user." };
  const filtered = users.filter((u) => u.username !== username);
  if (filtered.length === users.length) return { ok: false, error: "User not found." };
  saveUsers(filtered);
  return { ok: true };
}

export function setUserRole(username, role) {
  const users = loadUsers();
  const user = users.find((u) => u.username === username);
  if (!user) return { ok: false, error: "User not found." };
  const r = role === "admin" ? "admin" : "editor";
  user.role = r;
  saveUsers(users);
  return { ok: true };
}

export function checkLogin(username, password) {
  const users = loadUsers();
  const u = (username || "").trim().toLowerCase();
  const user = users.find((x) => x.username.toLowerCase() === u && x.password === password);
  return !!user;
}
